import API, { API_APP_KEY } from '../config/ApiConfig'

export const contactRoute = `${API}/contact?code=${API_APP_KEY}`
export const careers = `${API}/careers?code=${API_APP_KEY}`
export const search = `${API}/search?code=${API_APP_KEY}`
export const storiesSearch = `${API}/storiesSearch?code=${API_APP_KEY}`
export const suggest = `${API}/suggest`
export const jobSearch = `${API}/jobSearch?code=${API_APP_KEY}`
export const jobsFilters = `${API}/jobsFilters?code=${API_APP_KEY}`
export const productsSearch = `${API}/productsSearch?code=${API_APP_KEY}`
export const locationSearch = `${API}/locationsSearch?code=${API_APP_KEY}`
export const preview = `${API}/preview?code=${API_APP_KEY}`
